import React, { useMemo, useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Select,
  Option,
  MenuItem,
  MenuList,
  Menu,
  MenuHandler,
} from "@material-tailwind/react";
import api from "../../api/api";
import { toast } from "react-toastify";
import XCircleIcon from "@heroicons/react/24/solid/XCircleIcon";
import { countriess } from "../../utils/country";
import { useCountries } from "use-react-countries";
import { decrypt } from "../../utils/CryptData";

function AddSuppliers({ onSupplierAdded }) {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleOpen = () => setOpen((cur) => !cur);
  const { countries } = useCountries();
  const [country, setCountry] = useState(110);
  const { name, flags, countryCallingCode } = countries[country];



  const [supplier, setSupplier] = useState({
    name: "",
    contact_person: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    country: "",
  });

  const [fields] = useState([
    { label: "Nome et prénom(s)", name: "name", type: "text" },
    { label: "Contact d'urgence", name: "contact_person", type: "contact" },

    { label: "Contact", name: "phone", type: "tel" },
    { label: "email", name: "email", type: "email" },
    { label: "address", name: "address", type: "text" },
    { label: "Pays", name: "country", type: "select_Pays" },
    { label: "Ville", name: "city", type: "select_ville" },
  ]);

  const headers = useMemo(() => ({
    headers: {
      "Content-type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${JSON.parse( decrypt( localStorage.getItem("dus")))?.token || ''}`,
    },
  }), []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !supplier.name ||
      !supplier.contact_person ||
      !supplier.phone ||
      !supplier.email
    ) {
      toast.error("Tous les champs avec * sont require.");
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();

    formData.append("name", supplier.name);
    formData.append("contact_person", supplier.contact_person);
    formData.append("phone", supplier.phone);
    formData.append("email", supplier.email);
    formData.append("address", supplier.address);
    formData.append("city", supplier.city);
    formData.append("country", supplier.country);

    try {
      await api.post("products/suppliers", formData, headers);
      toast.success("Fournisseur ajouté avec succès");
      onSupplierAdded();
      handleOpen();
    } catch (error) {
      toast.error(error.response?.data?.message ?? "Erreur lors de l'ajout du fournisseur.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSupplier({
      ...supplier,
      [name]: value,
    });

  };



  return (
    <div>
      <Button className="shadow-none" variant="outlined"
        onClick={handleOpen}>
        Ajouter un fournisseur
      </Button>
      <Dialog
        size="xs"
        open={open}
        handler={handleOpen}
        className="bg-transparent shadow-none"
      >
        <Card className="mx-auto w-full max-w-[2xl]">
          <form onSubmit={handleSubmit}>
            <CardBody className="flex flex-col gap-3 ">
              <Typography
                variant="h3"
                color="blue-gray"
                className="text-center border-b"
              >
                Ajouter un fournisseur
              </Typography>
              <XCircleIcon
                className="block h-6 w-6 absolute top-3 right-3 cursor-pointer"
                aria-hidden="true"
                onClick={handleOpen}
              />
              {fields.map((input, index) => (
                <div className="" key={index}>
                  <Typography className="block text-gray-700 font-bold mb-2">
                    {input.label}:
                  </Typography>

                  {(() => {
                    switch (input.type) {
                      case "contact":

                        return (
                          <div className="flex">
                            <Menu placement="bottom-start">
                              <MenuHandler>
                                <Button
                                  ripple={false}
                                  variant="text"
                                  color="blue-gray"
                                  className="flex h-12 items-center gap-2 rounded-r-none  border-0  bg-gray-300 pl-3"
                                >
                                  <img
                                    src={flags.svg}
                                    alt={name}
                                    className="h-4 w-4 rounded-full object-cover"
                                  />
                                  {countryCallingCode}
                                </Button>
                              </MenuHandler>
                              <MenuList className="max-h-[20rem] max-w-[18rem]">
                                {countries.map(({ name, flags, countryCallingCode }, index) => {
                                  return (
                                    <MenuItem
                                      key={name}
                                      value={name}
                                      className="flex items-center gap-2"
                                      onClick={() => setCountry(index)}
                                    >
                                      <img
                                        src={flags.svg}
                                        alt={name}
                                        className="h-5 w-5 rounded-full object-cover"
                                      />
                                      {name} <span className="ml-auto">{countryCallingCode}</span>
                                    </MenuItem>
                                  );
                                })}
                              </MenuList>
                            </Menu>
                            <input
                              type="tel"
                              name='contact_person'
                              id='contact'
                              placeholder="Contact"
                              value={input.contact_person}
                              onChange={(e) =>
                                setSupplier({ ...supplier, contact_person: e.target.value })
                              }
                              className="file-input file-input-bordered w-full rounded-l-none pl-2"

                            />
                          </div>
                        );


                      case "tel":

                        return (
                          <div className="flex">
                            <Menu placement="bottom-start">
                              <MenuHandler>
                                <Button
                                  ripple={false}
                                  variant="text"
                                  color="blue-gray"
                                  className="flex h-12 items-center gap-2 rounded-r-none  border-0  bg-gray-300 pl-3"
                                >
                                  <img
                                    src={flags.svg}
                                    alt={name}
                                    className="h-4 w-4 rounded-full object-cover"
                                  />
                                  {countryCallingCode}
                                </Button>
                              </MenuHandler>
                              <MenuList className="max-h-[20rem] max-w-[18rem]">
                                {countries.map(({ name, flags, countryCallingCode }, index) => {
                                  return (
                                    <MenuItem
                                      key={name}
                                      value={name}
                                      className="flex items-center gap-2"
                                      onClick={() => setCountry(index)}
                                    >
                                      <img
                                        src={flags.svg}
                                        alt={name}
                                        className="h-5 w-5 rounded-full object-cover"
                                      />
                                      {name} <span className="ml-auto">{countryCallingCode}</span>
                                    </MenuItem>
                                  );
                                })}
                              </MenuList>
                            </Menu>
                            <input
                              type="tel"
                              name='contact'
                              id='contact'
                              placeholder="Contact"
                              value={input.phone}
                              onChange={(e) =>
                                setSupplier({ ...supplier, phone: e.target.value })
                              }
                              className="file-input file-input-bordered w-full rounded-l-none pl-2 "

                            />
                          </div>
                        );

                      case "select_Pays":
                        return (
                          <Select
                            label="Selectionné un pays"
                            className="w-full bg-transparent input input-bordered"
                            animate={{
                              mount: { y: 0 },
                              unmount: { y: 25 },
                            }}
                            name={input.name}
                            value={input.country}
                            onChange={(e) =>
                              setSupplier({ ...supplier, country: e })
                            }
                          >
                            {countriess.map((item) => (
                              <Option key={item.code} value={item.name}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        );

                      case "select_ville":
                        return (
                          <Select
                            label="Selectionné une ville"
                            className="w-full bg-transparent input input-bordered"
                            animate={{
                              mount: { y: 0 },
                              unmount: { y: 25 },
                            }}
                            name={input.name}
                            value={input.city}
                            onChange={(e) =>
                              setSupplier({ ...supplier, city: e })
                            }
                          >
                            {countriess.map((item, index) => (
                              <Option key={index} value={item.capital}>
                                {item.capital}
                              </Option>
                            ))}
                          </Select>
                        );
                      default:
                        return (
                          <Input
                            type={input.type}
                            name={input.name}
                            label={`${input.label}`}
                            value={supplier[input.name]}
                            onChange={handleChange}
                          />
                        );
                    }
                  })()}
                </div>
              ))}

              <div className="border-b"></div>
            </CardBody>
            <CardFooter className="pt-0 ">
              <Button
                type="submit"
                variant="gradient"
                fullWidth
                className="p-4 shadow-0 flex items-center justify-center gap-2"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                )}
                {isSubmitting ? "Ajout en cours..." : "Ajouter"}
              </Button>
            </CardFooter>
          </form>
        </Card>
      </Dialog>
    </div>
  )
}

export default AddSuppliers